import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EstatePackageCreationFiltering, EstatePackageCreationAddEdit } from './Pages';

export const EstatePackageCreationRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={EstatePackageCreationFiltering} />
        <Route exact path = {`${match.path}/AddEdit`} component={EstatePackageCreationAddEdit} />
    </Fragment>
)